import { createFileRoute } from "@tanstack/react-router";
import { ProfileSettings } from "~/routes/(restricted)/profil/-components/ProfileSettings";
import { ProfileSubscriptions } from "~/routes/(restricted)/profil/-components/ProfileSubscriptions";

export const Route = createFileRoute("/(restricted)/profil/")({
  component: RouteComponent,
  loader: async ({ context: { i18n } }) => {
    await i18n.loadNamespaces("profile");

    const title = i18n.t("profile:meta.title");

    return { meta: { title } };
  },
  head: async (context) => {
    return {
      meta: [
        {
          title: context.loaderData?.meta.title,
        },
      ],
    };
  },
});

function RouteComponent() {
  return (
    <div className="bg-background flex w-full max-w-206 flex-col gap-4 py-10">
      <ProfileSettings />
      <ProfileSubscriptions />
      <div className="pb-10" />
    </div>
  );
}
